import { useState } from "react";
import { signup } from "../data/auth";
import { PasswordField } from "./PasswordField";
export const SignupPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  return (
    <main className="miboard-auth-page">
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await signup(name, email, password);
            window.location.assign("/app/login");
          } catch {
            setMessage("Confira os dados e tente novamente.");
          }
        }}
        className="miboard-auth-card"
      >
        <img
          src="/image/Logo%20Miboard.png"
          alt="MiBoard"
          className="miboard-auth-logo"
        />
        <h1>Criar conta</h1>
        <p className="miboard-auth-description">
          Crie sua conta para começar a organizar seus painéis.
        </p>
        <label className="miboard-auth-label">
          Nome
          <input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="miboard-auth-input"
          />
        </label>
        <label className="miboard-auth-label">
          E-mail
          <input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="miboard-auth-input"
          />
        </label>
        <label className="miboard-auth-label">
          Senha
          <PasswordField
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            inputClassName="miboard-auth-input"
          />
        </label>
        {message && <p className="miboard-auth-message">{message}</p>}
        <button className="miboard-auth-submit" type="submit">
          Criar conta
        </button>
        <p className="miboard-auth-link">
          <a href="/app/login">Já tenho conta</a>
        </p>
      </form>
    </main>
  );
};
